module.exports = __webpack_public_path__ + "fonts/roboto-extra-light.9fc21af.woff";